import React from "react"
import PropTypes from "prop-types"
import * as Styled from "./Button.styled"
import {BUTTON_SIZES} from "./constants"

const ButtonWithIcon = ({
  size = "sm",
  disabled = false,
  icon,
  children,
  ...props
}) => {
  const hasChildren = React.Children.count(children) > 0

  return (
    <Styled.StyledButton
      btnsize={size}
      disabled={disabled}
      startIcon={icon}
      iconOnly={!hasChildren}
      {...props}
    >
      {children}
    </Styled.StyledButton>
  )
}

ButtonWithIcon.propTypes = {
  size: PropTypes.oneOf(Object.keys(BUTTON_SIZES)),
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  children: PropTypes.node,
}

export default ButtonWithIcon
